import { cn, type Merge } from '@sohanemon/utils';
import { KeyTech } from '@sohanscript/ui/key-tech';
import { Motion } from '@sohanscript/ui/motion';
import type { ComponentProps } from 'react';
import { Img } from '@/components/image';
import { Link } from '@/components/link';
import type { RouterOutputs } from '@/server/root';

export type ProjectGridItemProps = Merge<
	ComponentProps<typeof Motion>,
	RouterOutputs['project']['list'][number]
>;

export function ProjectGridItem({
	thumbnail,
	title,
	slug,
	tags,
	description,
	className,
	...props
}: ProjectGridItemProps) {
	return (
		<Motion feature="domMax" layoutId={slug?.current} {...props}>
			<Link
				to="/work/$slug"
				viewTransition
				state={{ transitionName: 'vt-work' }}
				params={{ slug: slug?.current ?? '' } as never}
				className={cn(
					'block max-w-sm rounded-xl corner-bevel bg-primary/5 p-4 shadow-lg ring-primary/30 transition-shadow hover:ring-1',
					className,
				)}
			>
				<div
					style={{ viewTransitionName: `vt-work-${slug?.current ?? ''}` }}
					className="relative h-72 w-full overflow-hidden rounded-[8px]"
				>
					<Img
						src={thumbnail}
						width={500}
						className="h-full w-full object-cover object-top ease-out"
					/>
				</div>
				<div className="flex items-center gap-1 pt-2">
					<p className="grow font-semibold text-primary">{title}</p>
					<KeyTech tags={tags ?? ''} />
				</div>
			</Link>
		</Motion>
	);
}
